import React, { useState, useEffect } from 'react';

const Settings = () => {
  const [settings, setSettings] = useState({
    websiteName: 'EduManage',
    contactEmail: 'info@edumanage.edu',
    contactPhone: '+1 (123) 456-7890',
    address: '123 Education Street, City, Country',
    socialLinks: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: ''
    }
  });

  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState(settings);

  useEffect(() => {
    setFormData(settings);
  }, [settings]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('social.')) {
      const socialField = name.split('.')[1];
      setFormData({
        ...formData,
        socialLinks: {
          ...formData.socialLinks,
          [socialField]: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleEditToggle = () => {
    if (editMode) {
      // Save changes
      setSettings(formData);
      alert('Settings updated successfully!');
    }
    setEditMode(!editMode);
  };

  const handleCancel = () => {
    setFormData(settings);
    setEditMode(false);
  };

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Website Settings</h1>
        
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold text-gray-800">General Settings</h2>
            <button
              onClick={handleEditToggle}
              className="bg-primary text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              {editMode ? 'Save Changes' : 'Edit Settings'}
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-700 mb-2">Website Name</label>
              {editMode ? (
                <input
                  type="text"
                  name="websiteName"
                  value={formData.websiteName}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded"
                />
              ) : (
                <p className="text-gray-800">{settings.websiteName}</p>
              )}
            </div>
            
            <div>
              <label className="block text-gray-700 mb-2">Contact Email</label>
              {editMode ? (
                <input
                  type="email"
                  name="contactEmail"
                  value={formData.contactEmail}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded"
                />
              ) : (
                <p className="text-gray-800">{settings.contactEmail}</p>
              )}
            </div>
            
            <div>
              <label className="block text-gray-700 mb-2">Contact Phone</label>
              {editMode ? (
                <input
                  type="tel"
                  name="contactPhone"
                  value={formData.contactPhone}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded"
                />
              ) : (
                <p className="text-gray-800">{settings.contactPhone}</p>
              )}
            </div>
            
            <div>
              <label className="block text-gray-700 mb-2">Address</label>
              {editMode ? (
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded"
                />
              ) : (
                <p className="text-gray-800">{settings.address}</p>
              )}
            </div>
          </div>
          
          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Social Media Links</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 mb-2">Facebook</label>
                {editMode ? (
                  <input
                    type="url"
                    name="social.facebook"
                    value={formData.socialLinks.facebook}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded"
                    placeholder="https://facebook.com/yourpage"
                  />
                ) : (
                  <p className="text-gray-800">{settings.socialLinks.facebook || 'Not set'}</p>
                )}
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Twitter</label>
                {editMode ? (
                  <input
                    type="url"
                    name="social.twitter"
                    value={formData.socialLinks.twitter}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded"
                    placeholder="https://twitter.com/yourpage"
                  />
                ) : (
                  <p className="text-gray-800">{settings.socialLinks.twitter || 'Not set'}</p>
                )}
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Instagram</label>
                {editMode ? (
                  <input
                    type="url"
                    name="social.instagram"
                    value={formData.socialLinks.instagram}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded"
                    placeholder="https://instagram.com/yourpage"
                  />
                ) : (
                  <p className="text-gray-800">{settings.socialLinks.instagram || 'Not set'}</p>
                )}
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">YouTube</label>
                {editMode ? (
                  <input
                    type="url"
                    name="social.youtube"
                    value={formData.socialLinks.youtube}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded"
                    placeholder="https://youtube.com/yourchannel"
                  />
                ) : (
                  <p className="text-gray-800">{settings.socialLinks.youtube || 'Not set'}</p>
                )}
              </div>
            </div>
          </div>
          
          {editMode && (
            <div className="mt-8 flex justify-end space-x-4">
              <button
                onClick={handleCancel}
                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition"
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;